module.exports = __webpack_public_path__ + "img/kommune-821.fbf3c9c2.svg";